import FormInput from 'components/Input/FormInput';
import React from 'react';

const ArticleNumberField: React.FC = () => {
	return <FormInput disabled={true} testId="ArticleNumberField" name="articleNumber" label="articleNumberLabel" />;
};

export default React.memo(ArticleNumberField);
